<template>
  <div class="cap-title-container" :style="{ backgroundColor }">
    <div class="cap-title-title-wrap cap-title-title-wrap--left">
      <div class="flex flex-between">
        <span
          class="cap-title-title-title"
          :style="{ color: titleColor }"
          :class="{bold: titleBold}"
        >{{ title }}</span>
        <div class="cap-title-title-link" v-show="isShowMore">
          <span class>查看更多</span>
          <span class="hmicon icon-youjiantou"></span>
        </div>
      </div>
      <div class="flex ">
        <div
          class="cap-title-title-sub flex-1"
          :style="{ color: subTitleColor }"
          :class="{ bold: subTitleBold }"
        >{{ subTitle }}</div>
        <div class="flex flex-end btn-wrapper" v-if="isShowCopyBtn">
          <el-button type="default" size="small" round>复制</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowMore: {
      type: Boolean,
      default: false,
    },
    titleBold: {
      type: Boolean,
      default: false,
    },
    subTitleBold: {
      type: Boolean,
      default: false,
    },
    isShowCopyBtn: {
      type: Boolean,
      default: false,
    },
    titleColor: {
      type: String,
      default: "#2b2b2b",
    },
    subTitleColor: {
      type: String,
      default: "#969799",
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    href: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.cap-title-container {
  padding: 0 16px;
}
.cap-title-title-wrap {
  position: relative;
  padding: 16px 0;
  word-break: break-all;
}
.cap-title-title-link {
  margin-left: 24px;
  font-size: 12px;
  color: #969799;
  white-space: nowrap;
  .hmicon {
    font-size: 12px;
  }
}

.cap-title-title-sub {
  font-size: 12px;
  margin-top: 10px;
}

.bold {
  font-weight: bold;
}

.btn-wrapper {
  margin-top: 20rpx;
}
</style>
